import { useContext } from 'react'

import { CapabilitiesFormContext } from './capabilities-context'

export function useCapabilitiesForm() {
  const ctx = useContext(CapabilitiesFormContext)
  if (!ctx) {
    throw new Error(
      'useCapabilitiesForm must be used within SupplierCapabilitiesFormProvider'
    )
  }
  return ctx
}
